/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type EvtWithdrawIneligibleReward = {
  pool: Address;
  rewardMint: Address;
  amount: bigint;
};

export type EvtWithdrawIneligibleRewardArgs = {
  pool: Address;
  rewardMint: Address;
  amount: number | bigint;
};

export function getEvtWithdrawIneligibleRewardEncoder(): FixedSizeEncoder<EvtWithdrawIneligibleRewardArgs> {
  return getStructEncoder([
    ["pool", getAddressEncoder()],
    ["rewardMint", getAddressEncoder()],
    ["amount", getU64Encoder()],
  ]);
}

export function getEvtWithdrawIneligibleRewardDecoder(): FixedSizeDecoder<EvtWithdrawIneligibleReward> {
  return getStructDecoder([
    ["pool", getAddressDecoder()],
    ["rewardMint", getAddressDecoder()],
    ["amount", getU64Decoder()],
  ]);
}

export function getEvtWithdrawIneligibleRewardCodec(): FixedSizeCodec<
  EvtWithdrawIneligibleRewardArgs,
  EvtWithdrawIneligibleReward
> {
  return combineCodec(
    getEvtWithdrawIneligibleRewardEncoder(),
    getEvtWithdrawIneligibleRewardDecoder(),
  );
}
